export const SearchIcon = () => {
  return (
    <span className="custom-svg">
      <svg
        width="16"
        height="16"
        viewBox="0 0 6 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.77089 3.32907H3.53919L3.45707 3.24993C3.80902 2.83956 3.99086 2.27971 3.89114 1.68469C3.75329 0.869829 3.07287 0.219113 2.25166 0.119453C1.01106 -0.0329666 -0.0330473 1.01052 0.119462 2.2504C0.21918 3.07113 0.870278 3.75115 1.68562 3.88892C2.28099 3.98858 2.84117 3.80685 3.25177 3.45511L3.33096 3.53718V3.76874L4.57743 5.01448C4.69768 5.13466 4.89418 5.13466 5.01443 5.01448C5.13468 4.8943 5.13468 4.69792 5.01443 4.57774L3.77089 3.32907ZM2.01117 3.32907C1.28088 3.32907 0.691372 2.73991 0.691372 2.01005C0.691372 1.28019 1.28088 0.691029 2.01117 0.691029C2.74145 0.691029 3.33096 1.28019 3.33096 2.01005C3.33096 2.73991 2.74145 3.32907 2.01117 3.32907Z"
          fill="white"
        />
      </svg>
    </span>
  );
};

export const ProviderProfileIcon = () => {
  return (
    <svg
      width="19"
      height="22"
      viewBox="0 0 19 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.18 21C18.18 17.13 14.33 14 9.59 14C4.85 14 1 17.13 1 21M9.59 11C10.9161 11 12.1879 10.4732 13.1255 9.53553C14.0632 8.59785 14.59 7.32608 14.59 6C14.59 4.67392 14.0632 3.40215 13.1255 2.46447C12.1879 1.52678 10.9161 1 9.59 1C8.26392 1 6.99215 1.52678 6.05447 2.46447C5.11678 3.40215 4.59 4.67392 4.59 6C4.59 7.32608 5.11678 8.59785 6.05447 9.53553C6.99215 10.4732 8.26392 11 9.59 11V11Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NetworkLogoutIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.9 6.56023C8.21 2.96023 10.06 1.49023 14.11 1.49023H14.24C18.71 1.49023 20.5 3.28023 20.5 7.75023V14.2702C20.5 18.7402 18.71 20.5302 14.24 20.5302H14.11C10.09 20.5302 8.24 19.0802 7.91 15.5402M1 11.0002H13.88"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6499 7.6499L14.9999 10.9999L11.6499 14.3499"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ExcelIcon = () => {
  return (
    <div className="svg-icon">
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 10L20.2 1.8M21 5.8V1H16.2M10 1H8C3 1 1 3 1 8V14C1 19 3 21 8 21H14C19 21 21 19 21 14V12"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const MerLibraryIcon = () => {
  return (
    <div className="svg-icon">
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 7.27V3.23C21 1.64 20.36 1 18.77 1H14.73C13.14 1 12.5 1.64 12.5 3.23V7.27C12.5 8.86 13.14 9.5 14.73 9.5H18.77C20.36 9.5 21 8.86 21 7.27ZM9.5 7.52V2.98C9.5 1.57 8.86 1 7.27 1H3.23C1.64 1 1 1.57 1 2.98V7.51C1 8.93 1.64 9.49 3.23 9.49H7.27C8.86 9.5 9.5 8.93 9.5 7.52ZM9.5 18.77V14.73C9.5 13.14 8.86 12.5 7.27 12.5H3.23C1.64 12.5 1 13.14 1 14.73V18.77C1 20.36 1.64 21 3.23 21H7.27C8.86 21 9.5 20.36 9.5 18.77Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5 16.5H19.5M16.5 19.5V13.5"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export const PhoneIcon = ({ color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 26 26"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginRight: "10px" }}
    >
      <path
        d="M5.16743 11.0865C7.16743 15.0171 10.3896 18.2393 14.3202 20.2393L17.3758 17.1838C17.7646 16.7949 18.3063 16.6838 18.7924 16.8365C20.348 17.3504 22.0146 17.6282 23.7508 17.6282C24.1191 17.6282 24.4724 17.7745 24.7329 18.035C24.9933 18.2955 25.1396 18.6487 25.1396 19.0171V23.8782C25.1396 24.2466 24.9933 24.5998 24.7329 24.8603C24.4724 25.1208 24.1191 25.2671 23.7508 25.2671C17.4887 25.2671 11.4831 22.7795 7.05518 18.3516C2.62724 13.9236 0.139648 7.91803 0.139648 1.65598C0.139648 1.28762 0.285977 0.934353 0.546444 0.673886C0.806912 0.413419 1.16018 0.26709 1.52854 0.26709H6.38965C6.758 0.26709 7.11127 0.413419 7.37174 0.673886C7.63221 0.934353 7.77854 1.28762 7.77854 1.65598C7.77854 3.39209 8.05631 5.05876 8.5702 6.61431C8.72298 7.10042 8.61187 7.64209 8.22298 8.03098L5.16743 11.0865Z"
        fill={color}
      />
    </svg>
  );
};
export const ExcelIconTest = () => {
  return (
    <div className="svg-icon">
      <svg
        width="20"
        height="16"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 10L20.2 1.8M21 5.8V1H16.2M10 1H8C3 1 1 3 1 8V14C1 19 3 21 8 21H14C19 21 21 19 21 14V12"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
